
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/scaletonloeder",
      function () {
        return require("private-next-pages/shop/scaletonloeder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/scaletonloeder"])
      });
    }
  